import { ChannelType } from '@vision/ui/enums';
import { IconWithDot } from '@vision/ui/components/IconWithDot';
import {
  CustomIconCatiChannel,
  CustomIconEmailSharing,
  CustomIconGooglePlayChannel,
  CustomIconIvrChannel,
  CustomIconLinkChannel,
  CustomIconMobileChannel,
  CustomIconQrChannel,
  CustomIconSikayetVarChannel,
  CustomIconSmsChannel,
  CustomIconWebWidgetChannel,
  CustomIconWhatsAppSharing,
} from '@vision/ui/icons';
import { CustomIconAppStoreChannel } from '@vision/ui/icons/CustomIconAppStoreChannel/CustomIconAppStoreChannel';
import { CustomIconGlassdoorChannel } from '@vision/ui/icons/CustomIconGlassdoorChannel/CustomIconGlassdoorChannel';
import { CustomIconGoogleMapsChannel } from '@vision/ui/icons/CustomIconGoogleMapsChannel/CustomIconGoogleMapsChannel';
import { CustomIconPushNotificationSharing } from '@vision/ui/icons/CustomIconPushNotificationSharing/CustomIconPushNotificationSharing';
import { CustomIconTrustpilotChannel } from '@vision/ui/icons/CustomIconTrustpilotChannel/CustomIconTrustpilotChannel';
const channelTypesWithoutDot = new Set<string>([
  ChannelType.APP_STORE.toLowerCase(),
  ChannelType.GLASSDOOR.toLowerCase(),
  ChannelType.GOOGLE_MAP.toLowerCase(),
  ChannelType.GOOGLE_PLAY.toLowerCase(),
  ChannelType.SIKAYET_VAR.toLowerCase(),
  ChannelType.TRUSTPILOT.toLowerCase(),
]);

const channelTypeDotColors: Record<string, string> = {
  [ChannelType.CATI.toLowerCase()]: '#FFC32F',
  [ChannelType.IVR.toLowerCase()]: '#FFB0DD',
  [ChannelType.LINK.toLowerCase()]: '#06C494',
  [ChannelType.MOBILE.toLowerCase()]: '#c7c9d9',
  [ChannelType.PUSH_NOTIFICATION.toLowerCase()]: 'orange.3',
  [ChannelType.EMAIL.toLowerCase()]: '#FF3B3B',
  [ChannelType.SMS.toLowerCase()]: '#00B7C4',
  [ChannelType.WEB_WIDGET.toLowerCase()]: '#0D7BFF',
};

function withChannelDot(icon: React.JSX.Element, size: number, dotColor: string): React.JSX.Element {
  return <IconWithDot dotColor={dotColor} dotSize={Math.round(size * 0.4)} height={size} icon={icon} width={size} />;
}

export function getChannelTypeIcon(channelType: string, size = 32): React.JSX.Element {
  const iconMap: Record<string, React.JSX.Element> = {
    [ChannelType.SMS.toLowerCase()]: <CustomIconSmsChannel width={size} height={size} />,
    [ChannelType.WEB_WIDGET.toLowerCase()]: <CustomIconWebWidgetChannel width={size} height={size} />,
    [ChannelType.WHATSAPP.toLowerCase()]: <CustomIconWhatsAppSharing width={size} height={size} />,
    [ChannelType.EMAIL.toLowerCase()]: <CustomIconEmailSharing width={size} height={size} />,
    [ChannelType.LINK.toLowerCase()]: <CustomIconLinkChannel width={size} height={size} />,
    [ChannelType.CATI.toLowerCase()]: <CustomIconCatiChannel width={size} height={size} />,
    [ChannelType.IVR.toLowerCase()]: <CustomIconIvrChannel width={size} height={size} />,
    [ChannelType.MOBILE.toLowerCase()]: <CustomIconMobileChannel width={size} height={size} />,
    [ChannelType.PUSH_NOTIFICATION.toLowerCase()]: <CustomIconPushNotificationSharing width={size} height={size} />,
    [ChannelType.GOOGLE_PLAY.toLowerCase()]: <CustomIconGooglePlayChannel width={size} height={size} />,
    [ChannelType.SIKAYET_VAR.toLowerCase()]: <CustomIconSikayetVarChannel width={size} height={size} />,
    [ChannelType.APP_STORE.toLowerCase()]: <CustomIconAppStoreChannel width={size} height={size} />,
    [ChannelType.KIOSK.toLowerCase()]: <CustomIconQrChannel width={size} height={size} />,
    [ChannelType.GLASSDOOR.toLowerCase()]: <CustomIconGlassdoorChannel width={size} height={size} />,
    [ChannelType.GOOGLE_MAP.toLowerCase()]: <CustomIconGoogleMapsChannel width={size} height={size} />,
    [ChannelType.TRUSTPILOT.toLowerCase()]: <CustomIconTrustpilotChannel width={size} height={size} />,
  };

  const normalizedType = channelType.toLowerCase();
  const icon = iconMap[normalizedType] || <CustomIconLinkChannel width={size} height={size} />;

  if (channelTypesWithoutDot.has(normalizedType)) {
    return icon;
  }

  return withChannelDot(icon, size, channelTypeDotColors[normalizedType] || '#06C494');
}
